<body>
    <form name="form" #f="ngForm" novalidate>
        <div class="form d-flex justify-content-center align-items-center">
            <div class="container fst-italic text-left w-75 mt-5">
                <div *ngIf="resetStatus == 'success'" class="page-text">
                    You have been successfully unsubscribed from our text notifications.
                </div>
                <div *ngIf="resetStatus != 'success'">
                    <div class="page-subtitle1 mb-2">Unsubscribe from Text Notifications</div>
                    <div class="page-text mb-5">Please use the form below to unsubscribe from our text notifications. Once unsubscribed, you will no longer receive updates or reminders via SMS text message.</div>
                    <div class="form-group mb-5">
                        <label class="control-label">Enter the phone number you wish to unsubscribe (no dashes, include area code)</label>
                        <div class="input-group mb-3">
                            <input type="text" [(ngModel)]="unsubscriber.phoneNumber" class="form-control" name="phoneNumber" #phoneNumber="ngModel" placeholder="" required pattern="\d{10}">
                            <div *ngIf="phoneNumber.invalid && phoneNumber.errors.pattern && (phoneNumber.dirty || formInvalid)" class="errormsg ml-2">Invalid</div>
                            <div *ngIf="phoneNumber.invalid && phoneNumber.errors.required && (phoneNumber.dirty || formInvalid)" class="errormsg ml-2">Required</div>                        
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="control-label">Reason for Unsubscribing (Optional)</label>
                        <label class="control-label">Please help us improve by sharing your reason</label>
                        <div *ngFor="let reason of unsubscribeReasons" class="ml-5">
                            <input type="radio" name="reason" [(ngModel)]="unsubscriber.reason" [value]="reason.description"><label class="ml-2">{{reason.description}}</label>
                        </div>
                    </div>                    
                    <div *ngIf="unsubscriber?.reason?.includes('I am the correct person')" class="form-group ml-5">
                        <label class="control-label">Please provide an email address where we can contact you</label>
                        <div class="input-group mb-3 ml-3">
                            <input type="text" [(ngModel)]="unsubscriber.email" class="form-control" name="email" #email="ngModel" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" required/>
                            <div *ngIf="email.invalid && (email.dirty || formInvalid) && email.errors.pattern" class="errormsg ml-2">Invalid</div> 
                            <div *ngIf="email.invalid && email.errors.required && (email.dirty || formInvalid)" class="errormsg ml-2">Required</div>                        
                        </div>
                    </div>                    
                    <div class="form-group text-right">
                        <button (click)="unsubscribe(f.form)" class="btn btn-general">Unsubscribe</button>
                    </div>
                </div>
                <ngx-spinner bdcolor="rgba(51,51,51,0.8)" size="default" type="ball-spin-clockwise">
                    <p style="color: white;">Please wait.</p>
                </ngx-spinner>
            </div>
        </div>
    </form>
</body>